<template>
  <div class="site-choose">
    <div class="product-list">
      <div
        class="cover-card"
        :class="{ 'invalid-input': !isValidCover(cover) }"
        v-for="(cover, index) of coverDataList"
        :key="index"
      >
        <div class="error-tip" v-if="!isValidCover(cover)">
          <span>文字长度不符合要求</span>
        </div>
        <span class="cover-name">{{ cover.sizeName }} （{{ cover.size.width }} * {{ cover.size.height }}）</span>
        <ai-cover
          :bgConfig="cover.bgParameter"
          :elementImg="cover.elementImg"
          :size="cover.size"
          :elConfig="cover.elementInfo"
          :textConfig="cover.textInfo"
          :fontStyles="cover.fontStyles"
        >
        </ai-cover>
      </div>
    </div>
    <div class="right-panel">
      <div class="product-name">选择封面尺寸</div>
      <cover-site-size />
    </div>
    <button class="editor-btn ai-btn" @click="editorDone">
      <span class="editor-text">编辑完成</span>
    </button>
  </div>
</template>
<script>
import coverSiteSize from "@/pages/ai/components/cover-size.vue";
import { mapState } from "vuex";
import aiCover from "./components/ai-cover.vue";
export default {
  name: "siteChoose",
  data() {
    return {
      // 某个封面合法输入
      legalInput: true,
    };
  },
  components: {
    aiCover,
    coverSiteSize,
  },
  async mounted() {
    this.validateTextLengths();
  },
  watch: {
    coverDataList: {
      handler() {
        this.validateTextLengths();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("cover", ["coverDataList", "coverData"]),
  },
  methods: {
    isValidCover(cover) {
      return cover.fontStyles.every(style => {
        if (!style.isShowText) return true;
        const textLength = style.text?.length || 0;
        // return (
        //   textLength >= style.textMinLength && textLength <= style.textMaxLength
        // );
        return textLength;
      });
    },
    validateTextLengths() {
      this.legalInput = this.coverDataList.every(cover => this.isValidCover(cover));
    },
    editorDone() {
      if (!this.legalInput) {
        this.$message.error("请检查每行文字的长度是否符合要求");
        return;
      }
      this.$router.replace("/ai/size-choose");
    },
  },
};
</script>
<style lang="scss" scoped>
.site-choose {
  padding: 24px;
  height: calc(100vh - 60px);
  background: #020202;
  .product-list {
    padding: 30px 50px;
    height: 100%;
    width: calc(100% - 424px);
    overflow: auto;
    background: rgba(33, 37, 49, 0.9);
    border-radius: 8px;
    .cover-card {
      margin-bottom: 24px;
      position: relative;
      .cover-name {
        display: block;
        margin-bottom: 4px;
        height: 24px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.6);
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 500;
      }
      &.invalid-input {
        outline: 1px solid #ff4d4f;
        border-radius: 4px;
      }
      .error-tip {
        position: absolute;
        top: -24px;
        left: 0;
        color: #ff4d4f;
        font-size: 14px;
        line-height: 20px;
        z-index: 1;
      }
    }
  }
}
.right-panel {
  position: fixed;
  top: 84px;
  bottom: 24px;
  right: 24px;
  padding: 24px;
  width: 400px;
  background: rgba(33, 37, 49, 0.9);
  border-radius: 16px;
  overflow: auto;
  .product-name {
    margin-bottom: 24px;
    display: block;
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
}
.editor-btn {
  position: fixed;
  bottom: 48px;
  right: 48px;
  z-index: 1000;
  width: 352px;
  .editor-text {
    display: block;
    height: 100%;
    line-height: 50px;
    cursor: pointer;
  }
}
.no-data {
  position: relative;
  z-index: 2;
  color: rgba(255, 255, 255, 1);
  height: 210px;
  line-height: 210px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  flex: 1;
  cursor: pointer;
}
</style>
